// extracted by mini-css-extract-plugin
module.exports = {"switcher":"index_switcher__1whS6","icon":"index_icon__85Ee2"};